import { useApolloClient } from "@apollo/client";
import { useEffect, useState } from "react";
import { fetchPlanPrice } from "utils/helpers/planPrices";

export const plansToPrice = (insurancePlans, selectedIds) => {
  if (!selectedIds || !selectedIds.length) return [];
  return (insurancePlans || []).filter((plan) => selectedIds.includes(plan.id));
};

export const usePlanPrices = (project, insurancePlans) => {
  const client = useApolloClient();
  const [planPrices, setPlanPrices] = useState({});
  const projectId = project && project.id;
  const selectedIds =
    (project && project.fields && project.fields.selectedToCompare) || [];
  const selectedKey = selectedIds.join(",");

  useEffect(() => {
    const plans = plansToPrice(insurancePlans, selectedIds);
    if (!projectId || !plans.length) return undefined;
    let cancelled = false;
    const fetchPrices = async () => {
      const prices = {};
      await Promise.all(
        plans.map(async (plan) => {
          const computeField = await fetchPlanPrice(client, projectId, plan.id);
          if (computeField?.formatted) {
            prices[plan.id] = computeField.formatted;
          }
        }),
      );
      if (!cancelled) setPlanPrices(prices);
    };
    fetchPrices();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insurancePlans.length, projectId, selectedKey, client]);

  return { planPrices };
};
